import { type MCPServerInfo } from '../../types';

const IntercomServer: MCPServerInfo = {
  serverId: 'INTERCOM',
  name: 'Intercom',
  slug: 'intercom',
  description:
    "Manage customer conversations, access support tickets, retrieve customer profiles, analyze conversation patterns, and handle customer service workflows through Intercom's messaging platform.",
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.intercom.com/mcp',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default IntercomServer;
